import { InputType } from './types';
import { Mask } from 'react-text-mask';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NumberMaskOptions } from '@types/text-mask-addons';

import createNumberMask from 'text-mask-addons/dist/createNumberMask';
/* TODO: react-input-mask doesn't support testing as per https://github.com/sanniassin/react-input-mask/issues/174 also not maintained anymore.
		Need to migrate to a testable library like https://github.com/s-yadav/react-number-format or https://nosir.github.io/cleave.js/
		*/
export type CurrencyMaskOptions = Partial<NumberMaskOptions>;
const defaultMaskOptions: CurrencyMaskOptions = {
	prefix: '$ ',
	suffix: '',
	includeThousandsSeparator: true,
	thousandsSeparatorSymbol: ',',
	allowDecimal: true,
	decimalSymbol: '.',
	decimalLimit: 2, // how many digits allowed after the decimal
	integerLimit: 12, // limit length of integer numbers
	allowNegative: false,
	allowLeadingZeroes: false,
};

const dict: { [key in InputType]?: Mask } = {
	CVV: [/\d/, /\d/, /\d/, /\d/],
	SSN: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	phoneNumber: [
		'+',
		'1',
		' ',
		/\d/,
		/\d/,
		/\d/,
		'-',
		/\d/,
		/\d/,
		/\d/,
		'-',
		/\d/,
		/\d/,
		/\d/,
		/\d/,
	],
	creditCard: [
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		' ',
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		' ',
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		' ',
		/\d/,
		/\d/,
		/\d/,
		/\d/,
	],
	currency: createNumberMask(defaultMaskOptions),
	dateOfBirth: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
};

const maskDict = (mask: InputType, currencyMaskOptions: CurrencyMaskOptions = {}) => {
	if (mask === 'currency') {
		return createNumberMask({ ...defaultMaskOptions, ...currencyMaskOptions });
	}
	return dict[mask];
};

export default maskDict;
